import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PaymentSummary from "../payment/PaymentSummary";
import PaymentQRCode from "../payment/PaymentQRCode";

import { useQrPayment } from "../payment/useQrPayment";

export default function Payment(props) {
  const navigate = useNavigate();
  //   const { state } = useLocation();
  const hasCreatedRef = useRef(false);

  //   // 🔒 guard state
  //   if (!state?.transaction || !state?.fee) {
  //     navigate("/", { replace: true });
  //     return null;
  //   }

  const { transaction, fee } = props;

  const { qr, status, remainingMs, createPayment } = useQrPayment({
    onSuccess: () => {
      setTimeout(() => {
        // navigate("/payment/success", { replace: true });
      }, 1500);
    },
  });

  // 🚀 auto create payment
  useEffect(() => {
    if (hasCreatedRef.current) return;
    hasCreatedRef.current = true;

    createPayment({
      session_id: transaction.id,
      full_amount: fee.summ - fee.paid,
      total_amount: fee.summ - fee.paid,
      //   full_amount: 1,
      //   total_amount: 1,
      branchcode: process.env.REACT_APP_PAYMENT_BRANCHCODE,
      app_name: process.env.REACT_APP_PAYMENT_APP_NAME,
    });
  }, [createPayment, transaction, fee]);

  return (
    <div className="Home">
      {/* <div className="card shadows logo p-4 mx-auto" style={{ maxWidth: 480 }}> */}
      <PaymentSummary data={transaction} fee={fee} />

      <PaymentQRCode qr={qr} status={status} remainingMs={remainingMs} />
      {/* </div> */}
    </div>
  );
}
